import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./routing/routes";
import { ScrollToTop, MultiLanguage } from "./Components";
import { PageNotFound } from "./pages";
import "./Default.css";
import { useSelector } from "react-redux";
import { useTextColorDynamic } from "./hooks";
const App = () => {
  const storeConfigState = useSelector((state) => state.storeSettings);
  const { getContrast } = useTextColorDynamic();
  useEffect(() => {
    const bodyStyles = document.body.style;
    if (storeConfigState?.themeConfigOthers?.primary_color === "") {
      bodyStyles.setProperty("--brand-color", "#251960");
    } else {
      const isContrast = getContrast(
        storeConfigState?.themeConfigOthers?.primary_color
      );

      if (isContrast === "black") {
        bodyStyles.setProperty("--brand-white", "#000000"); /*set black*/
      } else if (isContrast === "white") {
        bodyStyles.setProperty("--brand-white", "#ffffff"); /*set white*/
      }
      bodyStyles.setProperty(
        "--brand-color",
        storeConfigState?.themeConfigOthers?.primary_color
      );
    }
  }, []);
  return (
    <div>
      <MultiLanguage />
      <ScrollToTop />
      <Routes>
        {routes.map((route, key) => (
          <Route path={route.path} element={<route.component />} key={key} />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

export default App;
